import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {DataTableLocalization} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config/index";
import {connect} from "trim-redux";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../config/design/TableIcons";
import {withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import moment from "jalali-moment";
import {TableCount, TablePage} from "../../../../config/Permissions";
import Container from "@material-ui/core/Container/Container";
import Typography from "@material-ui/core/Typography/Typography";
import {Translate} from "../../../../config/Translate";
import AppCardLoaderTable from "../../../components/Skeletons/AppCardLoaderTable";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {currencySymbol, price} from "../../../../config/values";
import Button from "@material-ui/core/Button/Button";
import { Link as ReactLink } from "react-router-dom";

class Orders extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    state = {
        columns: [
            {
                field: 'buyer',
                editable: 'never',
                filtering: false,
                title: Translate.buyer,
            },
            {
                field: 'factor_number',
                editable: 'never',
                filtering: false,
                title: Translate.factor_number,
            },
            { title: Translate.totalPriceFull,
                field: 'total_price_payed',
                filterPlaceholder: Translate.search,
            },
            { title: Translate.totalUserDiscounts,
                field: 'total_discounts',
                filterPlaceholder: Translate.search,
            },
            { title: Translate.status,
                editable: 'never',
                field: 'status',
                filterPlaceholder: Translate.choose,
                lookup: {
                    "done" :
                        <Typography style={{color: "#38bf84"}}>{Translate.done}</Typography>
                    , "rejected":
                        <Typography color="textSecondary">{Translate.rejected}</Typography>
                    , "sending":
                        <Typography color="textPrimary">{Translate.sending}</Typography>
                    , "gathering":
                        <Typography color="textPrimary">{Translate.gathering}</Typography>
                    , "not_payed":
                        <Typography color="textSecondary">{Translate.not_payed}</Typography>
                    , "need_verification":
                        <Typography style={{color: "#631515"}}>{Translate.need_verification}</Typography>
                },
            },
            { title: Translate.created_at_factor,
                editable: 'never',
                filtering: false,
                field: 'created_at',
                render: rowData =>
                    <Typography className="date_in_table">
                        {`${moment(rowData.created_at).locale('fa').fromNow()}`}
                        <br/>
                        {`${moment(rowData.created_at).locale('fa').format( 'YYYY/M/D')}`}
                    </Typography>
            },
            {
                title: Translate.activity,
                field: 'activity',
                render: rowData =>
                    <>
                        <Button
                            color="primary"
                            size="small"
                            variant="outlined"
                            component={ReactLink}
                            to={`/order/manage/${rowData.id}`}
                        >
                            {Translate.view}
                        </Button>
                        {
                            (rowData.status === "not_payed" || rowData.status === "need_verification")  &&
                            <Button
                                className="mx-5"
                                onClick={() => this.handleRemoveItem(rowData.id)}
                                size="small"
                                style={{color:"#f82e4e",marginRight:5}}
                            >
                                {Translate.remove}
                            </Button>
                        }
                    </>
            }
        ],
        data: [],
        loading:false,
        ChangeLoader:false
    };
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }
    handleRemoveItem(id){
        let data = new FormData();
        data.append('id', id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/factor/remove`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.dataRemoved, {
                    variant: 'success',
                });
                this.loadData();
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.dataRemovingFailed, {
                    variant: 'error',
                });

            });

        this.setState({
            loading:false,
            SubmitLoading:false
        });
    }
    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl" className={!!this.props.widget ? "thin-table" : null}>
                            <MaterialTable
                                tableRef={this.tableRef}
                                icons={tableIcons}
                                title={" "}
                                localization={DataTableLocalization}
                                columns={this.state.columns}
                                data={query =>
                                    new Promise((resolve, reject) => {
                                        axios.get(`${defaultVariabls.url}/factors/quickView?page=${query.page + 1}&per_page=${query.pageSize}&search=${query.search}`, config)
                                            .then(response => {
                                                let data = [];
                                                // eslint-disable-next-line
                                                response.data.data.map((row) => {
                                                    data.push({
                                                        total_price_payed: price(row.total_price_payed) +" "+currencySymbol,
                                                        id: row.id,
                                                        factor_number: row.number,
                                                        buyer: row.user.first_name +" "+row.user.last_name,
                                                        total_discounts: price(row.total_discount_code_price + row.total_discount_price) +" "+currencySymbol,
                                                        status: row.status,
                                                        created_at: row.created_at,
                                                    })
                                                });
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })
                                            }).catch(error => {
                                            console.log(error.response)
                                        })
                                    })
                                }
                                options={{
                                    pageSize: TablePage,
                                    pageSizeOptions: TableCount,
                                    /*search:false,*/
                                }}
                            />
                        </Container>
                }
            </>

        );
    }
}

const mstp = state => ({
    locale: state.locale,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Orders)))));